import React from 'react'
import EnvironmentContext from './EnvironmentContext'
import EnvironmentContextInterface from './EnvironmentContextInterface'
import LoadingScreen from '../../components/LoadingScreen/LoadingScreen'

interface EnvironmentProviderProps {
  children: React.ReactNode
  error?: any
  environment?: EnvironmentContextInterface
}

export default function EnvironmentProvider(props: EnvironmentProviderProps) {
  const {children, error, environment} = props

  return !error && environment ? (
    <EnvironmentContext.Provider value={environment}>{children}</EnvironmentContext.Provider>
  ) : (
    <LoadingScreen />
  )
}
